<template>
  <bar-card :loading="loading" :bar-click="handleClickBar" @reload="init()">
    <template #bar_tab>
      <BarCardTab
        title="発表中の気象注意報・警報など"
        icon="mdi-weather-pouring"
      />
    </template>
    <div class="d-flex align-center text-body-2 px-2 pt-2">
      <div v-if="!!announceDatetime">
        <span class="mx-2 text-sm-body-2 text-caption">{{
          announceDatetime
        }}</span>
        <span class="text-sm-body-2 text-caption">更新</span>
      </div>
      <v-spacer></v-spacer>
      <div>
        <a
          href="https://www.jma.go.jp/bosai/map.html#10/35.016/138.005/&elem=all&contents=warning"
          target="_blank"
        >
          <span>
            気象庁HP
            <v-icon small class="mx-0">
              mdi-open-in-new
            </v-icon>
          </span>
        </a>
      </div>
    </div>
    <div class="mt-2 px-2">
      <div class="d-flex align-center flex-wrap jma-legend-row">
        <span class="jma-legend-category text-caption font-weight-bold">気象</span>
        <span
          v-for="it in legendWeather"
          :key="it.fieldPath"
          class="jma-legend-item text-caption mx-1"
        >
          <span
            class="jma-legend-dot"
            :class="{ 'jma-legend-dot--bordered': !it.dark }"
            :style="{ backgroundColor: it.color }"
          ></span>
          {{ it.label }}
        </span>
      </div>
      <div class="d-flex align-center flex-wrap jma-legend-row">
        <span class="jma-legend-category text-caption font-weight-bold">津波</span>
        <span
          v-for="it in legendTsunami"
          :key="it.fieldPath"
          class="jma-legend-item text-caption mx-1"
        >
          <span
            class="jma-legend-dot"
            :class="{ 'jma-legend-dot--bordered': !it.dark }"
            :style="{ backgroundColor: it.color }"
          ></span>
          {{ it.label }}
        </span>
      </div>
    </div>
    <div class="mt-2">
      <v-simple-table>
        <tbody>
          <tr
            v-for="{ Id, Name, __hasData, __hasInfo, __info } in displayRecords"
            :key="Id"
          >
            <td>
              {{ Name }}
            </td>
            <td>
              <template v-if="!__hasData">
                情報はありません。
              </template>
              <template v-else-if="!__hasInfo">
                発表はありません。
              </template>
              <template v-else>
                <div class="d-flex mx-n1">
                  <JMATypeLavel
                    v-for="it in __info"
                    :key="`${Id}${Name}${it.fieldPath}${it.label}`"
                    :color="it.color"
                    :dark="it.dark"
                    :value="it.label"
                    wrapper-class="mx-0"
                  />
                </div>
              </template>
            </td>
          </tr>
        </tbody>
      </v-simple-table>
    </div>
  </bar-card>
</template>

<script>
import BarCard from '@/components/common/BarCard';
import BarCardTab from '@/components/common/BarCardTab';
import JMATypeLavel from '@/components/app/JMATypeLavel.vue';

import { infoType } from '@/assets/js/objects/CDS_T_JMAInfo__c';

export default {
  components: {
    BarCard,
    BarCardTab,
    JMATypeLavel,
  },
  data: () => ({
    loading: false,

    // 発表日時
    announceDatetime: null,

    // レコード
    records: [],
  }),

  computed: {
    legendWeather() {
      return infoType.filter(
        (v) => v.showLegend && !v.legendOnly
      );
    },
    legendTsunami() {
      return infoType.filter(
        (v) => v.showLegend && v.legendOnly
      );
    },
    displayRecords() {
      return this.records.map((r) => {
        // 最新報のレコードを取り出し
        const latest = r.JMAInfoToJMAInfoM__r?.[0];

        const __info =
          (latest &&
            _.sortBy(infoType, 'order').reduce((prev, next) => {
              const value = latest[next.fieldPath];
              if (!value) return prev;

              const values = value.split(';').map((v) => v.trim()).filter((v) => !!v);

              return [
                ...prev,
                ...values.map((v) => {
                  let label = v;
                  let color = next.color;
                  let dark = next.dark;

                  // 選択肢ごとの色指定がある場合はそちらを優先
                  if (next.colorMap && next.colorMap[v]) {
                    color = next.colorMap[v].color;
                    dark = next.colorMap[v].dark;
                  }

                  // 警戒レベル相当情報（レベル表記あり）
                  if (next.levelTypes && next.levelTypes.includes(v)) {
                    label = `レベル${next.levelNumber}${v}${next.levelName}`;
                  }
                  // 警戒レベル対象外情報（レベル表記なし）
                  else if (next.traditionalTypes && next.traditionalTypes.includes(v)) {
                    label = `${v}${next.levelName}`;
                  }

                  return {
                    ...next,
                    label,
                    color,
                    dark,
                  };
                }),
              ];
            }, [])) ||
          [];

        return {
          ...r,
          // 最新報が存在するか
          __hasData: !!latest,
          // 情報は存在するか
          __hasInfo: __info.length > 0,
          __info,
        };
      });
    },
  },

  async mounted() {
    await this.init();
  },

  methods: {
    async init() {
      this.loading = true;
      await Promise.all([this.getStat()]);
      this.$nextTick(() => {
        this.loading = false;
      });
    },
    // 情報の取得
    async getStat() {
      const { objList = null, announceDatetime = null } =
        (await this.$con.invoke({
          controller: this.$pageProperty.controller,
          method: 'getJMAInfoStat',
          params: {
            disasterId: this.$store.state.disaster.disaster.Id,
          },
        })) || {};

      if (objList) {
        this.records = objList;
      }

      if (announceDatetime) {
        this.$set(
          this,
          'announceDatetime',
          this.$dateFns.fnsFormat(
            announceDatetime,
            '',
            'yyyy年MM月dd日(E) HH:mm',
          ),
        );
      }
    },
    handleClickBar() {
      this.$transition.to(
        'CDS_VF_JMAInfoList',
        {},
        {
          notApplyRetUrl: true,
        },
      );
    },
  },
};
</script>

<style scoped>
.jma-legend-row {
  margin-bottom: 2px;
}
.jma-legend-category {
  min-width: 28px;
  color: #666;
}
.jma-legend-item {
  display: inline-flex;
  align-items: center;
  white-space: nowrap;
}
.jma-legend-dot {
  display: inline-block;
  width: 10px;
  height: 10px;
  border-radius: 2px;
  margin-right: 3px;
}
.jma-legend-dot--bordered {
  border: 1px solid #9e9e9e;
}
</style>
